module.exports = __webpack_public_path__ + "static/img/mobile_icon.0cd9c907.png";